
























































import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { ButtonType } from '@getaccept/lib-ui';
import { logOut } from '@getaccept/lib-shared/src/helpers/log-out.helper';
import { useEnvironment } from '@getaccept/lib-shared/src/composables/environment.composable';
import NotFoundSVG from './components/not-found/assets/NotFound.svg';
import { Error } from './stores/required-app-data.store';

export default defineComponent({
  components: {
    NotFoundSVG,
  },
  props: {
    error: {
      type: String as PropType<Error>,
      required: true,
    },
  },
  setup() {
    const { isLocalHost } = useEnvironment();

    const reloadPage = () => {
      window.location.reload();
    };

    const contactSupport = () => {
      window.open('http://help.getaccept.com/', '_blank');
    };

    const backToLogin = () => {
      logOut();

      if (isLocalHost.value) {
        window.location.href = '/login';
      }
    };

    return {
      ButtonType,
      Error,
      reloadPage,
      backToLogin,
      contactSupport,
    };
  },
});
